<template>
  <div>
    <call />
    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right">
        <div class="l-header__column l-header__column--left w-60">
          <router-link to="/about"><img src="/assets/images/icon/icon-back-arrow.svg" alt="" /></router-link>
        </div>
        <div class="l-header__column l-header__column--mid">
          オープンソースライセンス
        </div>
        <div class="l-header__column l-header__column--right w-60"></div>
      </div>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                Firebase <br />
                <span>Copyright 2020 Firebase, Inc.</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                Vue.js v2.6.12 <br />
                <span>(c) 2014-2020 Evan You</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                vuex v2.0.0 <br />
                <span>(c) 2016 Evan You</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                FullCalendar v5.3.2 <br />
                <span>(c) 2020 Adam Shaw</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                jQuery JavaScript Library v3.5.1 <br />
                Includes Sizzle.js<br />
                <span>Copyright JS Foundation and other contributors</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                Slide and swipe menu <br />
                <span>copyright Copyright 2013-2015 Joan claret</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                TouchSwipe 1.6.18<br />
                <span>Copyright (c) 2010-2015 Matt Bryson</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                Mobile Detect<br />
                <span>Copyright 2013, Heinrich Goebl,</span>
              </div>
            </div>
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                Swiper 6.2.0<br />
                <span>Copyright 2014-2020 Vladimir Kharlampidi</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Vue from "vue";
import { Common } from "../common/common.js";

export default Vue.extend({
  name: 'OpenSourceLicense',
  components: {
  },
  mixins: {
    Tenant
  },
  mounted() {
    Common.initDom();
  }
})
</script>